export function getTypedValues(key: string | undefined, data: any): any {
  if (data == null) {
    return null;
  }

  if (typeof data === "string" || data instanceof String) {
    return key;
  }

  if (Array.isArray(data) || data instanceof Array) {
    return key as string;
  }

  const dataObject = data as { [key: string]: any };
  const subData: { [key: string]: any } = {};
  for (const subKey of Object.keys(data)) {
    subData[subKey] = getTypedValues(key ? `${key}.${subKey}` : subKey, dataObject[subKey]);
  }

  return subData;
}
